function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M.469 16h8.5c.259 0 .468-.21.468-.469v-.5a.938.938 0 0 0-.937-.937v-.56c0-.743-.604-1.347-1.346-1.347h-4.87c-.743 0-1.347.604-1.347 1.346v.56a.937.937 0 0 0-.937.938v.5c0 .259.21.469.469.469z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M5.866 10.323a.938.938 0 0 0 1.498-1.128L4.543 5.45A.937.937 0 1 0 3.045 6.58z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M12.605 5.245a.937.937 0 1 0 1.497-1.128L11.282.373a.938.938 0 1 0-1.498 1.129z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M10.549 7.969a5.085 5.085 0 0 0 1.538-1.853L8.804 1.76a5.087 5.087 0 0 0-2.205.968A5.086 5.086 0 0 0 5.061 4.58l3.282 4.357a5.083 5.083 0 0 0 2.206-.968z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M11.814 8.09a6.278 6.278 0 0 1-.701.627 6.306 6.306 0 0 1-.796.502l.611.811 1.498-1.128z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#57595a",
  d: "M12.99 9.65l-1.497 1.129 2.82 3.744a.937.937 0 1 0 1.498-1.129z"
})))));

var SvgIconLawyerFirm = function SvgIconLawyerFirm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLawyerFirm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-lawyer-firm.7e5e1e4b.svg";
export { ForwardRef as ReactComponent };